export default __webpack_public_path__ + "static/campaign-fi-736b7d7c4c572da3c0fe20a1bdaec022.webm";